import { render, staticRenderFns } from "./ChartFields.vue?vue&type=template&id=c2166486&"
import script from "./ChartFields.vue?vue&type=script&lang=ts&"
export * from "./ChartFields.vue?vue&type=script&lang=ts&"
import style0 from "./ChartFields.vue?vue&type=style&index=0&id=c2166486&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports